import React from 'react';
import {
  CardTitle,
  Card,
  CardContent,
  Textarea,
} from '../../../Components';
import { PreProjetoModel } from '../../../Store';
import styled from 'styled-components';

interface IPreProjetoModalProps {
  preprojeto: PreProjetoModel,
  onClose: () => void;
}

const StyledTextarea = styled(Textarea) <any>`
  margin: 0;
  grid-column: ${p => p.gridColumn};
`

const Div = styled.div`
  display: flex;
  flex-direction: column;
`

const P = styled.p`
  margin: 0 1em 0 1em;
`

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Fundo semitransparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Fica abaixo do ModalWrapper */
`

const ModalWrapper = styled.div`
  position: relative;
  background-color: white;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  max-height: 80vh; /* Limita a altura máxima do modal */
  overflow-y: auto; /* Adiciona a rolagem vertical */
  width: 700px; /* Ajuste a largura conforme necessário */
  z-index: 1000; /* Garante que esteja acima do fundo */
`

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px; /* Define a largura do quadrado */
  height: 30px; /* Define a altura do quadrado */
  background-color: white; /* Fundo do quadrado */
  border: 2px solid red; /* Borda vermelha do quadrado */
  border-radius: 4px; /* Opcional: arredonda os cantos */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: red;
  cursor: pointer;
  padding: 0;

  &:hover {
    background-color: red; /* Muda a cor de fundo ao passar o mouse */
    color: white; /* Muda a cor do "x" ao passar o mouse */
  }
`

export default function PreProjetoModal(props: IPreProjetoModalProps) {
  const { preprojeto, onClose } = props;

  const handleBackgroundClick = (e: React.MouseEvent) => {
    // Verifica se o clique foi diretamente no ModalBackground e não em seus filhos (o modal)
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      {preprojeto && 
        <ModalBackground onClick={handleBackgroundClick}>
          <ModalWrapper>
            <CloseButton onClick={onClose} style={{ fontWeight: 'bold' }}>×</CloseButton>
            <Card>         
              <CardTitle>Detalhes do Pré-Projeto</CardTitle>
              <CardContent>
                <Div>
                  <P>Título: </P>
                  <StyledTextarea
                    name='titulo'
                    defaultValue={preprojeto.titulo}
                    maxLength={3}
                    gridColumn='1/4'
                    disabled={true}
                  />
                  <P>Tema: </P>
                  <StyledTextarea
                    name='titulo'
                    defaultValue={preprojeto.tema}
                    maxLength={3}
                    gridColumn='1/4'
                    disabled={true}
                  />
                  <P>Justificativa: </P>
                  <StyledTextarea
                    name='titulo'
                    defaultValue={preprojeto.justificativa}
                    maxLength={3}
                    gridColumn='1/4'
                    disabled={true}
                  />
                  <P>Desenvolvimento: </P>
                  <StyledTextarea
                    name='titulo'
                    defaultValue={preprojeto.desenvolvimento}
                    maxLength={3}
                    gridColumn='1/4'
                    disabled={true}
                  />
                  <P>Bibliografia: </P>
                  <StyledTextarea
                    name='titulo'
                    defaultValue={preprojeto.bibliografia}
                    maxLength={3}
                    gridColumn='1/4'
                    disabled={true}
                  />
                </Div>
              </CardContent>
            </Card>
          </ModalWrapper>
        </ModalBackground>
      }
    </>
  );
}
